<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      home: "/home",
    };
  },
};
</script>

<style lang="scss">
@import "./scss/iconfont";
@import "./scss/color";
@import "./scss/fontsize";
@import "./scss/constant";
@import "./scss/layout";

/*滚动条整体样式*/
.mainlogo {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 999;
  width: 100px;
  height: 100px;
  mix-blend-mode: exclusion;
  .logo-black {
    width: 70px;
    height: 70px;
    margin: 30px 0 0 30px;
  }
}
.mainlogopoint {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100px;
  height: 100px;
  z-index: 999;
  i {
    display: block;
    width: 8px;
    height: 8px;
    background: #07d79b;
    margin: 66px 0 0 92px;
  }
}
@media screen and (max-width: 768px) {
  .mainlogo {
    width: 65px;
    height: 65px;
    .logo-black {
      width: 45px;
      height: 45px;
      margin: 20px 0 0 20px;
    }
  }
  .mainlogopoint {
    width: 65px;
    height: 65px;
    i {
      width: 5px;
      height: 5px;
      margin: 43px 0 0 60px;
    }
  }
}
</style>
